import { Button, type ButtonProps } from "react-bootstrap";
import { MdAddCircle } from "react-icons/md";

const AddButton: TTButtonProps = ({ children, ...props }) => {
  return (
    <Button variant="secondary" {...(props as ButtonProps)}>
      <MdAddCircle /> {children}
    </Button>
  );
};

export default AddButton;
